module.exports = __webpack_public_path__ + "assets/images/USDNEW20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDNEW20.png
// module id = 1462
// module chunks = 1